export const categories = [
  {
    id: 'latest',
    slug: 'latest',
    name: '最新热播',
    description: '最新上线的热门国产内容，每日更新，紧跟潮流',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    id: 'classic',
    slug: 'classic',
    name: '经典回顾',
    description: '历久弥新的经典国产佳作，值得反复品味',
    icon: 'ri-vip-crown-line',
    color: 'primary',
  },
  {
    id: 'hd',
    slug: 'hd',
    name: '高清精选',
    description: '高清画质精选内容，极致视觉享受',
    icon: 'ri-4k-line',
    color: 'secondary',
  },
  {
    id: 'collection',
    slug: 'collection',
    name: '热门合集',
    description: '精心整理的系列合集，一次看过瘾',
    icon: 'ri-stack-line',
    color: 'accent',
  },
  {
    id: 'exclusive',
    slug: 'exclusive',
    name: '独家首发',
    description: '平台独家首发内容，抢先体验',
    icon: 'ri-sparkling-line',
    color: 'primary',
  },
  {
    id: 'recommended',
    slug: 'recommended',
    name: '口碑推荐',
    description: '用户好评如潮的优质推荐，不容错过',
    icon: 'ri-thumb-up-line',
    color: 'secondary',
  },
];